(function () {
  'use strict';
  if (window.__pgStoreReviews) return;
  window.__pgStoreReviews = true;
  var feeds = new Map();
  var observer = 'IntersectionObserver' in window ? new window.IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      init(entry.target);
    });
  }, {rootMargin: '300px'}) : null;

  function text(node, selector) {
    var element = node.querySelector(selector);
    return element ? element.textContent.trim() : '';
  }
  function safePhoto(value) {
    try {
      var url = new URL(value);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
    } catch (_) { return ''; }
  }
  function parseReview(node) {
    var ratingNode = node.querySelector('.jdgm-rev__rating');
    var dateNode = node.querySelector('.jdgm-rev__timestamp');
    var body = node.querySelector('.jdgm-rev__body');
    // Preserve paragraph boundaries without inserting third-party HTML.
    if (body) body.querySelectorAll('br').forEach(function (br) { br.replaceWith('\n'); });
    var paragraphs = body ? Array.from(body.querySelectorAll('p')).map(function (p) { return p.textContent.trim(); }) : [];
    return {
      id: node.dataset.reviewId,
      body: paragraphs.length ? paragraphs.join('\n\n') : text(node, '.jdgm-rev__body'),
      author: text(node, '.jdgm-rev__author'),
      product: text(node, '.jdgm-rev__prod-link'),
      rating: Number(ratingNode && ratingNode.dataset.score),
      date: dateNode ? dateNode.dataset.content.replace(' UTC', 'Z').replace(' ', 'T') : '',
      verified: node.dataset.verifiedBuyer === 'true',
      photos: Array.from(node.querySelectorAll('.jdgm-rev__pic-link')).map(function (a) {
        return safePhoto(a.getAttribute('href'));
      }).filter(Boolean)
    };
  }
  async function fetchReviews(config) {
    var rows = [], seen = new Set();
    for (var page = 1; page <= 1000; page++) {
      var url = new URL('https://api.judge.me/api/v1/widgets/all_reviews_page');
      // Judge.me does not support the X-Api-Token CORS preflight. This is the
      // public, read-only widget token, explicitly intended for browser URLs.
      url.search = new URLSearchParams({shop_domain: config.shop, page: String(page), review_type: 'product-reviews', api_token: config.publicToken});
      var response = await fetch(url.href, {signal: AbortSignal.timeout(15000)});
      if (!response.ok) throw new Error('Review widget unavailable');
      var payload = await response.json();
      if (typeof payload.all_reviews !== 'string') throw new Error('Invalid review page');
      var doc = new DOMParser().parseFromString(payload.all_reviews, 'text/html');
      var nodes = Array.from(doc.querySelectorAll('.jdgm-rev'));
      if (!nodes.length) return rows.sort(function (a, b) { return (Date.parse(b.date) || 0) - (Date.parse(a.date) || 0); });
      var previous = seen.size;
      nodes.forEach(function (node) {
        var row = parseReview(node);
        if (!row.id || seen.has(row.id)) return;
        seen.add(row.id);
        if (row.body && Number.isInteger(row.rating) && row.rating >= 1 && row.rating <= 5) rows.push(row);
      });
      if (seen.size === previous) throw new Error('Review pagination repeated');
    }
    throw new Error('Review pagination limit reached');
  }
  function label(config, key, value) { return config[key].replace('__VALUE__', String(value)); }
  function cardFor(row, template, config) {
    var card = template.content.querySelector('[data-review-id]').cloneNode(true);
    card.dataset.reviewId = row.id;
    card.hidden = false;
    card.querySelector('[data-review-body]').textContent = row.body;
    card.querySelector('[data-review-body]').style.whiteSpace = 'pre-line';
    card.querySelector('cite').textContent = row.author;
    card.querySelector('[data-review-product]').textContent = row.product;
    var stars = card.querySelector('.pg-stars');
    stars.textContent = '★'.repeat(row.rating) + '☆'.repeat(5 - row.rating);
    stars.setAttribute('aria-label', label(config, 'ratingLabel', row.rating));
    var verified = card.querySelector('[data-review-verified]');
    if (!row.verified) verified.remove();
    var time = card.querySelector('time');
    if (Number.isFinite(Date.parse(row.date))) {
      time.dateTime = row.date;
      time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {year:'numeric',month:'short',day:'numeric'}).format(new Date(row.date));
    } else time.remove();
    card.querySelector('[data-review-expand]').setAttribute('aria-label', label(config, 'authorLabel', row.author));
    card.querySelectorAll('.pg-judgeme-photo,.pg-review-media').forEach(function (node) { node.remove(); });
    card.removeAttribute('data-review-photo');
    row.photos.forEach(function (url, index) {
      var link = document.createElement('button'), img = document.createElement('img');
      link.type = 'button'; link.className = 'pg-judgeme-photo'; link.dataset.reviewPhotoSrc = url;
      link.disabled = true; link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-label', label(config, 'openPhotoLabel', index + 1));
      var thumbnail = new URL(url);
      if (thumbnail.hostname === 'review-images.judgeme.com') {
        thumbnail.searchParams.set('width', '192');
        thumbnail.searchParams.set('quality', '75');
      }
      img.src = thumbnail.href; img.alt = label(config, 'photoLabel', index + 1); img.loading = 'lazy'; img.decoding = 'async';
      img.width = 96; img.height = 96;
      link.appendChild(img);
      var media = card.querySelector('.pg-review-media');
      if (!media) { media = document.createElement('div'); media.className = 'pg-review-media'; card.querySelector('.pg-judgeme-copy').appendChild(media); }
      media.appendChild(link);
    });
    return card;
  }
  function init(stage) {
    if (stage.dataset.storeReviewsState && stage.dataset.storeReviewsState !== 'pending') return;
    var config = stage.querySelector('[data-store-reviews-config]').dataset;
    var template = stage.querySelector('[data-store-review-template]');
    stage.dataset.storeReviewsState = 'loading';
    var key = config.shop + ':' + config.publicToken;
    if (!feeds.has(key)) feeds.set(key, fetchReviews(config).catch(function (error) { feeds.delete(key); throw error; }));
    feeds.get(key).then(function (rows) {
      if (!stage.isConnected) return;
      var fragment = document.createDocumentFragment();
      rows.forEach(function (row) { fragment.appendChild(cardFor(row, template, config)); });
      function apply() {
        if (!stage.isConnected) return;
        if (stage.hasAttribute('data-review-open') || stage.contains(document.activeElement)) return;
        stage.removeEventListener('pg:review-toggle', apply);
        stage.removeEventListener('focusout', afterFocus);
        stage.querySelectorAll('[data-feedback]').forEach(function (card) { card.remove(); });
        stage.insertBefore(fragment, stage.querySelector('[data-feedback-controls]'));
        stage.closest('[data-raptor-section]').hidden = !rows.length;
        stage.dataset.storeReviewsState = 'loaded';
        stage.dispatchEvent(new CustomEvent('pg:reviews-updated'));
      }
      function afterFocus() { setTimeout(apply, 0); }
      stage.addEventListener('pg:review-toggle', apply);
      stage.addEventListener('focusout', afterFocus);
      apply();
    }).catch(function (error) {
      stage.dataset.storeReviewsState = 'error';
      console.warn('Store review selection could not refresh:', error.message);
    });
  }
  function scan(root) {
    function schedule(stage) {
      if (stage.dataset.storeReviewsState) return;
      if (!observer) { init(stage); return; }
      // Native Liquid cards stay visible while the live feed waits offscreen.
      stage.dataset.storeReviewsState = 'pending';
      observer.observe(stage);
    }
    if (root.matches && root.matches('[data-store-reviews]')) schedule(root);
    root.querySelectorAll('[data-store-reviews]').forEach(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }, {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
}());
